import { render } from "./reader.vue?vue&type=template&id=0a25f73f&scoped=true"
import script from "./reader.vue?vue&type=script&lang=js"
export * from "./reader.vue?vue&type=script&lang=js"

import "./reader.vue?vue&type=style&index=0&id=0a25f73f&scoped=true&lang=css"

import exportComponent from "D:\\html\\bracelet-management-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a25f73f"]])

export default __exports__